import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'

export const getListTaskStatus = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(
        `sprintflow/task/status?project_id=${params.project_id}&sprintflow_id=${params.sprintflow_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const addTaskStatus = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`sprintflow/task/status`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const updateTaskStatus = async ({ params, token }) => {
  try {
    return await clientPublic
      .put(`sprintflow/task/status/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteTaskStatus = async ({ params, token }) => {
  try {
    return await clientPublic
      .delete(
        `sprintflow/task/status/${params.id}?project_id=${params.project_id}&sprintflow_id=${params.sprintflow_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
